import { IInputProps } from 'modules';
import React, { FC } from 'react';

export const InputFile: FC<IInputProps> = ({
  onChange,
  onTouched,
  value,
  isReadOnly,
  onFocus,
}) => {
  return (
    <input
      type={'file'}
      id={'csvFileInput'}
      accept={'.csv'}
      onChange={(e) => onChange(e.target.files)}
    />
  );
};
